export default function ProgramImage({ program, className = "" }) {
  const contain = program.fit === "contain";
  return (
    <div className="relative h-full w-full overflow-hidden bg-slate-100">
      {contain && (
        <img
          src={program.image}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover scale-110 blur-2xl opacity-50"
        />
      )}
      <img
        src={program.image}
        alt={program.name}
        style={{ filter: program.filter }}
        className={`absolute inset-0 h-full w-full ${contain ? "object-contain" : "object-cover"} ${className}`}
      />
    </div>
  );
}
